import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export const Summary = () => (
  <section className="py-12 max-w-4xl mx-auto px-6">
    <h3 className="text-2xl font-bold text-brand-black mb-6 text-center">Fórmula simple para tu próximo post</h3>
    
    <div className="bg-brand-black text-white p-6 md:p-8 rounded-2xl shadow-lg mb-8 text-center">
      <p className="text-lg md:text-xl font-bold leading-relaxed">
        <span className="text-brand-cyan">Problema</span> + <span className="text-brand-cyan">Servicio</span> + <span className="text-brand-cyan">Ciudad/Área</span> + <span className="text-brand-cyan">Resultado</span> + <span className="text-brand-cyan">Tip</span> + <span className="text-brand-cyan">CTA</span>
      </p>
    </div>

    <div className="bg-white border border-gray-200 p-6 md:p-8 rounded-2xl shadow-sm">
      <h4 className="text-sm font-bold text-brand-gray uppercase tracking-wider mb-4">Ejemplo de Caption Completo</h4>
      <p className="text-brand-black text-base md:text-lg leading-relaxed font-medium italic">
        "Reparamos drywall con daño causado por una fuga en una casa de Vacaville. Antes de pintar, fue necesario confirmar que la humedad ya estaba controlada. Pintar directamente sobre el daño puede esconder el problema, pero no lo resuelve. Mándanos mensaje si tienes daño en paredes o techo y necesitas una revisión."
      </p>
    </div>
  </section>
);

export const AIGuide = () => (
  <section className="py-12 bg-brand-light">
    <div className="max-w-4xl mx-auto px-6">
      <h3 className="text-2xl font-bold text-brand-black mb-6">Cómo usar AI con esta checklist</h3>
      <div className="prose prose-lg text-brand-gray">
        <p className="mb-4">
          Puedes usar herramientas como ChatGPT, Claude, Gemini u otra herramienta de AI para ayudarte a convertir fotos, notas y proyectos terminados en publicaciones más claras.
        </p>
        <p className="mb-6">
          No tienes que empezar pagando. Pero si ya usas AI cada semana para tu negocio, una cuenta pagada puede ayudarte a trabajar de forma más organizada, guardar contexto y crear mejores instrucciones para tu negocio.
        </p>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-xl">
          <p className="text-yellow-800 font-medium m-0 flex gap-3">
            <SafeIcon icon={FiIcons.FiAlertCircle} className="text-xl flex-shrink-0 mt-0.5" />
            <span><strong>Nota importante:</strong> AI no reemplaza tu experiencia como dueño de negocio. AI te ayuda a ordenar tus ideas, escribir más claro y ahorrar tiempo.</span>
          </p>
        </div>
      </div>
    </div>
  </section>
);

export const Tools = () => (
  <section className="py-16 max-w-5xl mx-auto px-6">
    <h3 className="text-2xl font-bold text-brand-black mb-10 text-center">Herramientas que pueden ayudarte</h3>
    
    <div className="grid md:grid-cols-3 gap-6">
      <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow">
        <div className="w-12 h-12 bg-cyan-50 rounded-xl flex items-center justify-center mb-4 text-brand-cyan text-xl">
          <SafeIcon icon={FiIcons.FiMessageSquare} />
        </div>
        <h4 className="text-lg font-bold text-brand-black mb-3">Para escribir y ordenar ideas</h4>
        <p className="text-brand-gray mb-6 flex-grow">
          Usa ChatGPT, Claude o Gemini para convertir tus notas en captions, ideas de videos y respuestas a preguntas frecuentes.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow">
        <div className="w-12 h-12 bg-cyan-50 rounded-xl flex items-center justify-center mb-4 text-brand-cyan text-xl">
          <SafeIcon icon={FiIcons.FiCalendar} />
        </div>
        <h4 className="text-lg font-bold text-brand-black mb-3">Para programar publicaciones</h4>
        <p className="text-brand-gray mb-6 flex-grow">
          Herramientas como Publer pueden ayudarte a programar contenido en varias plataformas y mantener más consistencia.
        </p>
        <a 
          href="https://publer.io/digitaltrack"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center w-full py-3 px-4 bg-gray-100 text-brand-black font-bold rounded-xl hover:bg-gray-200 transition-colors"
        >
          Ver Publer
        </a>
      </div>

      <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow">
        <div className="w-12 h-12 bg-brand-black rounded-xl flex items-center justify-center mb-4 text-brand-cyan text-xl">
          <SafeIcon icon={FiIcons.FiTrendingUp} />
        </div>
        <h4 className="text-lg font-bold text-brand-black mb-3">Para mejorar tu presencia local</h4>
        <p className="text-brand-gray mb-6 flex-grow">
          Si necesitas ayuda con Google Business Profile, redes sociales, reseñas, sitio web o visibilidad local, DigitalTrack puede ayudarte.
        </p>
        <a 
          href="https://digitaltrack.co/free-consultation"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center w-full py-3 px-4 bg-brand-cyan text-brand-black font-bold rounded-xl hover:bg-opacity-90 transition-colors"
        >
          Agendar consulta gratis
        </a>
      </div>
    </div>
  </section>
);

export const FinalCTA = () => (
  <section className="py-20 bg-brand-black text-center px-6">
    <div className="max-w-3xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6">
        ¿Quieres que revisemos tu presencia digital?
      </h2>
      <p className="text-lg text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto">
        Si tienes un negocio de servicios del hogar y quieres que más clientes locales entiendan qué haces, dónde trabajas y cómo contactarte, agenda una consulta gratis con DigitalTrack.
      </p>
      
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a 
          href="https://digitaltrack.co/free-consultation"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto px-8 py-4 bg-brand-cyan text-brand-black font-bold rounded-xl hover:bg-opacity-90 transition-all shadow-lg transform hover:-translate-y-0.5"
        >
          Agendar consulta gratis
        </a>
        <a 
          href="https://publer.io/digitaltrack"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-brand-gray text-white font-bold rounded-xl hover:border-gray-400 hover:text-white transition-all"
        >
          Revisar Publer
        </a>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-white py-10 px-6 border-t border-gray-100 text-center">
    <div className="max-w-4xl mx-auto">
      <div className="text-xl font-bold tracking-tight mb-2">
        <span className="text-brand-gray">digital</span>
        <span className="text-brand-cyan">Track</span>
      </div>
      <p className="text-brand-black font-semibold mb-4">
        Digital Marketing
      </p>
      <p className="text-brand-gray text-sm mb-6">
        Helping local businesses get found online and attract more customers.
      </p>
      <p className="text-xs text-gray-400 max-w-xl mx-auto leading-relaxed">
        Algunos enlaces pueden ser enlaces de referencia o afiliados. Solo recomendamos herramientas que tienen sentido para este flujo de trabajo.
      </p>
    </div>
  </footer>
);